import React from 'react';

import { Date, ImageWrapper, Name, Wrapper } from './styles';

const formatName = (name: string) => {
  const nameLength = name.length;
  if (nameLength > 50) {
    const format = name.substring(name.lastIndexOf('.') + 1, nameLength);
    const newName = name.slice(0, 40) + `....${format}`;
    return newName;
  } else {
    return name;
  }
};

const formatDate = (date: string) => date.slice(0, 10);

export interface Props {
  isActive: boolean;
  name: string;
  date: string;
  imageSrc: string;
  onSelectImg: () => void;
}

const ImageCard = ({ isActive, name, date, imageSrc, onSelectImg }: Props) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key == ' ') {
      onSelectImg();
    }
  };

  return (
    <Wrapper isActive={isActive} onClick={onSelectImg} tabIndex={0} onKeyDown={handleKeyDown}>
      <ImageWrapper imageSrc={imageSrc} />
      <Name>{formatName(name)}</Name>
      <Date>{formatDate(date)}</Date>
    </Wrapper>
  );
};

export default ImageCard;
